import $ from 'jquery'

const MESSAGE_BAR_SELECTOR = '.topic-list__bottom'
const MESSAGE_BAR_ACTIVE_CLASS = 'topic-list__bottom--active'

class MessageBar {
  constructor() {
    this.messageBar = $(MESSAGE_BAR_SELECTOR)
    this.window = $(window)

    this.prevScrollPos = 0

    this.init()
  }

  init() {
    this.listen()
  }

  listen() {
    this.window.on('scroll', event => {
      event.preventDefault()
      const currentScrollPos = this.window.scrollTop()

      if (this.prevScrollPos < currentScrollPos) {
        this.hideMessageBar()
      } else {
        this.showMessageBar()
      }

      this.prevScrollPos = currentScrollPos
    })
  }

  showMessageBar() {
    this.messageBar.addClass(MESSAGE_BAR_ACTIVE_CLASS)
  }

  hideMessageBar() {
    this.messageBar.removeClass(MESSAGE_BAR_ACTIVE_CLASS)
  }
}

export default MessageBar
